<template>
  <div>
    <form method="post" @submit.prevent="activateCoinAccount">
      <div class="card">
        <div class="card-body">
          <h4>{{ $t('phrase.activate_coin_account') }}</h4>
          <p class="text-muted">
            {{ $t('sentence.activate_coin_account_explanation') }}
          </p>

          <div class="row">
            <div class="col-md-4">
              <v-text-input
                id="activate-coin-account-zip"
                v-model="formData.zip"
                label="word.zip"
                help-text="phrase.zip_four_digits"
                :max-length="4"
                :required="true"
                :errors="errors.zip"
              />
            </div>
            <div class="col-md-4">
              <v-single-select
                id="activate-coin-account-gender"
                v-model="formData.gender"
                label="word.gender"
                help-text="phrase.select_gender"
                :choices="GENDER_CHOICES"
                :required="true"
                :errors="errors.gender"
              />
            </div>
            <div class="col-md-4">
              <v-date-input
                id="activate-coin-account-birth-date"
                v-model="formData.birth_date"
                label="word.birth_date"
                help-text="phrase.select_birth_date"
                :required="true"
                :max-date="new Date()"
                :min-date="new Date(1900, 1, 1)"
                :errors="errors.birth_date"
              />
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
          <v-button
            id="activate-coin-account-submit"
            text="word.save"
            type="submit"
            :loader="loader"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import DateInput from '@/common/components/inputs/DateInput.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import SingleSelect from '@/common/components/inputs/SingleSelect.vue';
import api from '@/common/api';
import { toFormattedDate } from '@/common/utils/formatting';
import { mapActions, mapGetters } from 'vuex';
import { GENDER_CHOICES } from '@/common/utils/constants';

export default {
  name: 'ActivateCoinAccount',
  components: {
    'v-button': Button,
    'v-date-input': DateInput,
    'v-single-select': SingleSelect,
    'v-text-input': TextInput,
  },
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      GENDER_CHOICES,
      loader: { loading: false },
      errors: {},
      formData: {
        zip: '',
        gender: '',
        birth_date: null,
      },
    };
  },
  methods: {
    ...mapActions(['refreshUser']),
    async activateCoinAccount() {
      this.errors = [];
      this.loader.loading = true;

      const response = await api.patch(
        `coin-accounts/${this.user.coin_account.id}/activate/`,
        {
          zip: this.formData.zip,
          gender: this.formData.gender,
          birth_date: toFormattedDate(this.formData.birth_date),
        },
      );

      if (response.status === 400) {
        this.errors = response.data;
        this.loader.loading = false;
        return;
      }

      await this.refreshUser();
      await this.$router.push({ name: 'reviewer-dashboard' });
    },
  },
  created() {
    this.formData.zip = this.user.profile.zip || null;
    this.formData.gender = this.user.profile.gender || null;
    if (this.user.profile.birth_date) {
      this.formData.birth_date = new Date(this.user.profile.birth_date);
    }
  },
};
</script>
